import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { Job } from '@shared';
import { companyDescription, DescriptionObject, jobDescription } from './description-constants';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { AppFeatureExtensions } from '@app/app-feature-extensions.config';
import { take } from 'rxjs/operators';

@Component({
  selector: 'mojo-jobs-form-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
  // TODO: add custom change emitter on validation
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobDescriptionFormComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() job: Partial<Job>;

  constructor(public featureExtensionService: MojoFeatureExtensionsService) {}

  ngOnInit(): void {
    this.featureExtensionService
      .hasFeatureExtension(AppFeatureExtensions.JOB_DEFAULT_DESCRIPTION)
      .pipe(take(1))
      .subscribe((hasFeatureExtension) => {
        if (hasFeatureExtension) {
          this.getDefaultValuesForDescriptionFields();
        }
      });
  }

  private getDefaultValuesForDescriptionFields() {
    const companyDescriptionForm = this.form.get('companyDescription');
    const jobDescriptionForm = this.form.get('description');
    if (!companyDescriptionForm.value) {
      this.mapEntityDescriptionValue(companyDescription, companyDescriptionForm);
    }
    if (!jobDescriptionForm.value) {
      this.mapEntityDescriptionValue(jobDescription, jobDescriptionForm);
    }
  }

  private mapEntityDescriptionValue(
    descriptionObjArray: DescriptionObject[],
    entityDescriptionForm: AbstractControl,
  ) {
    const descriptionText = descriptionObjArray
      .map((descriptionObj) => {
        const title = `<p><strong>${descriptionObj.title}</p></strong>`;
        const points = descriptionObj.points;
        const body =
          points.length > 1
            ? '<ul>' + points.map((point) => `<li>${point}</li>`).join('') + '</ul>'
            : `<p>${points.toString()}</p><br>`;
        return title + body;
      })
      .join('');
    entityDescriptionForm.setValue(descriptionText);
  }
}
